import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static phoneNumber(control: AbstractControl): ValidationErrors | null {
    const phonePattern = /^\+1\d{10}$/;
    const phone = control.value.replace(/\D/g, '');
    if (phone.length === 10 || (phone.length === 11 && phone.startsWith('1'))) {
      return null;
    }
    return { pattern: true };
  }

  static dateOfBirth(control: AbstractControl): ValidationErrors | null {
    const dobPattern = /^(0?[1-9]|1[0-2])[\/\-](0?[1-9]|[12][0-9]|3[01])[\/\-]\d{4}$/;
    if (!dobPattern.test(control.value)) {
      return { invalidDate: true };
    }
    return null;
  }
}
